import * as React from "react";

function SvgIcons8RemoveProperty(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M4 5v22h15v-2H6V11h20v6h2V5zm2 2h20v2H6zm3 7v2h2v-2zm4 0v2h10v-2zm-4 4v2h2v-2zm4 0v2h6v-2zm12 1c-.55 0-1 .45-1 1h-4v2h12v-2h-4c0-.55-.45-1-1-1zm-4 4v7c0 1.094.906 2 2 2h6c1.094 0 2-.906 2-2v-7h-2v7h-6v-7z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8RemoveProperty);
